var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescQuadroFnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 812,
    height: 929.999,
    viewBox: "0 0 812 929.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Base-fnb",
    x: 206.5,
    y: 0,
    width: 593,
    height: 479,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-fnb-2",
    x: 150.5,
    y: 410.999,
    width: 653,
    height: 519,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-fnb-3",
    x: 12.5,
    y: 169,
    width: 643,
    height: 602,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quadro_fnb",
    transform: "translate(-968 -1893.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8854",
    "data-name": "Rectangle 8854",
    width: 812,
    height: 730,
    transform: "translate(968 1988)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(4 -65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card_Arrivals_1",
    "data-name": "Card Arrivals 1",
    transform: "translate(1300 2076)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -336, -117.5)",
    filter: "url(#Base-fnb)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-fnb-4",
    "data-name": "Base",
    width: 338,
    height: 224,
    transform: "translate(332 122.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-more-vert",
    "data-name": "Icon metro-more-vert",
    d: "M17.924,12.712a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,17.924,12.712Zm0,2.5a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,17.924,15.212Zm0,7.5a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,17.924,22.712Z",
    transform: "translate(297.576 17.288)",
    fill: "#3a4750",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_name_",
    "data-name": "{name}",
    transform: "translate(12 43)",
    fill: "#3a4750",
    fontSize: 24,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Restaurant Beach")), /*#__PURE__*/React.createElement("g", {
    id: "Group_42403",
    "data-name": "Group 42403",
    transform: "translate(-4 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PAX",
    transform: "translate(9.798 97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adulti"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_adults",
    d: "M947.749,344.637H936.208a.37.37,0,0,1-.358-.367c-.021-.527-.024-1.8.391-2.218l.115-.123a3.7,3.7,0,0,1,2.561-1.212c1.285-.2,1.508-.766,1.582-.952l.006-.018c-.009-.207-.022-.438-.03-.6a2.876,2.876,0,0,1-.9-1.169.919.919,0,0,1-.623-.835l-.015-.111a.39.39,0,0,1-.005-.089,2.529,2.529,0,0,1,.43-1.461.562.562,0,0,1,.274-.147,5.527,5.527,0,0,1,.028-.884c.091-.945.494-1.561,1.105-1.682l.188-.039.017-.027a.511.511,0,0,1,.46-.2l.61-.131a1.193,1.193,0,0,1,.917.5c.03.033.071.079.1.112a.942.942,0,0,1,.509,0c.826.166.8,1.12.794,1.528,0,.069,0,.138,0,.207a2.127,2.127,0,0,1,.019.641.526.526,0,0,0,.069,0h0a.575.575,0,0,1,.47.225,2.271,2.271,0,0,1,.173,1.48,1.136,1.136,0,0,1-.639.8l-.1.064a3.715,3.715,0,0,1-.8,1.256c-.018.179-.046.477-.056.6v.015c.021.613.875.835,1.38.915a3.766,3.766,0,0,1,2.6,1.231l.1.107a4.431,4.431,0,0,1,.52,2.177.4.4,0,0,1-.1.285A.349.349,0,0,1,947.749,344.637Zm-11.186-.767h10.8a3.594,3.594,0,0,0-.273-1.265l-.114-.123a3.116,3.116,0,0,0-2.193-1.008c-1.694-.262-1.977-1.143-1.995-1.643.007-.22.071-.87.071-.87a.4.4,0,0,1,.12-.247,2.941,2.941,0,0,0,.754-1.179.378.378,0,0,1,.148-.194l.214-.137c.273-.172.276-.181.3-.292a2.441,2.441,0,0,0,0-.781.828.828,0,0,1-.64-.255.568.568,0,0,1-.106-.477,1.45,1.45,0,0,0,.006-.561,2.53,2.53,0,0,1-.009-.343c.013-.537-.037-.72-.2-.753a.869.869,0,0,0-.178-.021.5.5,0,0,1-.325.04.9.9,0,0,1-.5-.358c-.1-.107-.24-.268-.325-.268l-.561.128a.418.418,0,0,1-.243.158,2.213,2.213,0,0,1-.41.107c-.391.078-.5.733-.523,1.012a5.121,5.121,0,0,0-.022.857.583.583,0,0,1-.107.463.629.629,0,0,1-.43.235,2.853,2.853,0,0,0-.166.854c.005.037.009.072.013.1a.755.755,0,0,0,.018.111.781.781,0,0,0,.3.169.376.376,0,0,1,.2.219,2.109,2.109,0,0,0,.828,1.056.386.386,0,0,1,.172.3s.032.537.047.915a.405.405,0,0,1-.074.25,2.5,2.5,0,0,1-2.133,1.4,3.055,3.055,0,0,0-2.149.989c-.048.053-.093.1-.138.147A3.257,3.257,0,0,0,936.562,343.87Zm3.2-7.773h0Zm4.589-.533h0Zm-4.707-.077a.108.108,0,0,0,0,.018Z",
    transform: "translate(-929.64 -326.752)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(25 18)",
    fill: "#55595c",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), /*#__PURE__*/React.createElement("g", {
    id: "Kids",
    transform: "translate(57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-2",
    "data-name": "icona"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-5",
    "data-name": "Base",
    width: 25,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_kids",
    d: "M1018.85,340.207a2.055,2.055,0,0,1-2.281,0,.5.5,0,0,0-.711-.04.516.516,0,0,0-.039.722,2.955,2.955,0,0,0,3.784,0,.512.512,0,0,0-.042-.707.506.506,0,0,0-.706.024ZM1014.989,338a.6.6,0,1,0,1.209,0h0a.6.6,0,1,0-1.209,0Zm4.231,0a.6.6,0,1,0,1.209,0h0a.6.6,0,1,0-1.209,0Zm4.04,1.022h0c-.01,0-.049-.006-.057-.006a.5.5,0,0,0-.543.418,5.021,5.021,0,0,1-9.9,0,.544.544,0,0,0-.539-.409h-.051a.512.512,0,0,1-.011-1.023h0c.008,0,.048.007.056.007a.5.5,0,0,0,.544-.418,5.087,5.087,0,0,1,2.535-3.559,3.15,3.15,0,0,0,2.872,2.583h.028a.5.5,0,0,0,.484-.373c0-.008.235-.794.828-.966a.513.513,0,0,0,.347-.632.5.5,0,0,0-.623-.352h0a2.281,2.281,0,0,0-1.36,1.255,2.3,2.3,0,0,1-1.632-1.921,5.008,5.008,0,0,1,6.278,3.364,5.086,5.086,0,0,1,.144.6.5.5,0,0,0,.543.417s.042,0,.059-.008a.457.457,0,0,1,.492.42h0a.474.474,0,0,1,0,.089.508.508,0,0,1-.494.516Zm.307-2.015a6.021,6.021,0,0,0-11.715,0,1.538,1.538,0,0,0,0,3,6.02,6.02,0,0,0,11.715,0,1.533,1.533,0,0,0,1.195-1.5,1.469,1.469,0,0,0-1.195-1.5Z",
    transform: "translate(-1005.375 -326.596)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(25 18)",
    fill: "#55595c",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42126",
    "data-name": "Group 42126",
    transform: "translate(16 60)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Lunch",
    transform: "translate(0 17)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lunch")), /*#__PURE__*/React.createElement("text", {
    id: "_10_",
    "data-name": "(10)",
    transform: "translate(52 17)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(10)")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42487",
    "data-name": "Group 42487",
    transform: "translate(-4 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42400",
    "data-name": "Group 42400",
    transform: "translate(16 154)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dinner",
    transform: "translate(0 17)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dinner")), /*#__PURE__*/React.createElement("text", {
    id: "_34_",
    "data-name": "(34)",
    transform: "translate(55 17)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(34)"))), /*#__PURE__*/React.createElement("g", {
    id: "PAX-2",
    "data-name": "PAX",
    transform: "translate(16 191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adulti-2",
    "data-name": "Adulti",
    transform: "translate(-6.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-3",
    "data-name": "icona"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_adults-2",
    "data-name": "ic_adults",
    d: "M947.749,344.637H936.208a.37.37,0,0,1-.358-.367c-.021-.527-.024-1.8.391-2.218l.115-.123a3.7,3.7,0,0,1,2.561-1.212c1.285-.2,1.508-.766,1.582-.952l.006-.018c-.009-.207-.022-.438-.03-.6a2.876,2.876,0,0,1-.9-1.169.919.919,0,0,1-.623-.835l-.015-.111a.39.39,0,0,1-.005-.089,2.529,2.529,0,0,1,.43-1.461.562.562,0,0,1,.274-.147,5.527,5.527,0,0,1,.028-.884c.091-.945.494-1.561,1.105-1.682l.188-.039.017-.027a.511.511,0,0,1,.46-.2l.61-.131a1.193,1.193,0,0,1,.917.5c.03.033.071.079.1.112a.942.942,0,0,1,.509,0c.826.166.8,1.12.794,1.528,0,.069,0,.138,0,.207a2.127,2.127,0,0,1,.019.641.526.526,0,0,0,.069,0h0a.575.575,0,0,1,.47.225,2.271,2.271,0,0,1,.173,1.48,1.136,1.136,0,0,1-.639.8l-.1.064a3.715,3.715,0,0,1-.8,1.256c-.018.179-.046.477-.056.6v.015c.021.613.875.835,1.38.915a3.766,3.766,0,0,1,2.6,1.231l.1.107a4.431,4.431,0,0,1,.52,2.177.4.4,0,0,1-.1.285A.349.349,0,0,1,947.749,344.637Zm-11.186-.767h10.8a3.594,3.594,0,0,0-.273-1.265l-.114-.123a3.116,3.116,0,0,0-2.193-1.008c-1.694-.262-1.977-1.143-1.995-1.643.007-.22.071-.87.071-.87a.4.4,0,0,1,.12-.247,2.941,2.941,0,0,0,.754-1.179.378.378,0,0,1,.148-.194l.214-.137c.273-.172.276-.181.3-.292a2.441,2.441,0,0,0,0-.781.828.828,0,0,1-.64-.255.568.568,0,0,1-.106-.477,1.45,1.45,0,0,0,.006-.561,2.53,2.53,0,0,1-.009-.343c.013-.537-.037-.72-.2-.753a.869.869,0,0,0-.178-.021.5.5,0,0,1-.325.04.9.9,0,0,1-.5-.358c-.1-.107-.24-.268-.325-.268l-.561.128a.418.418,0,0,1-.243.158,2.213,2.213,0,0,1-.41.107c-.391.078-.5.733-.523,1.012a5.121,5.121,0,0,0-.022.857.583.583,0,0,1-.107.463.629.629,0,0,1-.43.235,2.853,2.853,0,0,0-.166.854c.005.037.009.072.013.1a.755.755,0,0,0,.018.111.781.781,0,0,0,.3.169.376.376,0,0,1,.2.219,2.109,2.109,0,0,0,.828,1.056.386.386,0,0,1,.172.3s.032.537.047.915a.405.405,0,0,1-.074.25,2.5,2.5,0,0,1-2.133,1.4,3.055,3.055,0,0,0-2.149.989c-.048.053-.093.1-.138.147A3.257,3.257,0,0,0,936.562,343.87Zm3.2-7.773h0Zm4.589-.533h0Zm-4.707-.077a.108.108,0,0,0,0,.018Z",
    transform: "translate(-929.64 -326.752)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_27",
    "data-name": 27,
    transform: "translate(25 18)",
    fill: "#55595c",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "27"))), /*#__PURE__*/React.createElement("g", {
    id: "Kids-2",
    "data-name": "Kids",
    transform: "translate(57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-4",
    "data-name": "icona"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-6",
    "data-name": "Base",
    width: 25,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_kids-2",
    "data-name": "ic_kids",
    d: "M1018.85,340.207a2.055,2.055,0,0,1-2.281,0,.5.5,0,0,0-.711-.04.516.516,0,0,0-.039.722,2.955,2.955,0,0,0,3.784,0,.512.512,0,0,0-.042-.707.506.506,0,0,0-.706.024ZM1014.989,338a.6.6,0,1,0,1.209,0h0a.6.6,0,1,0-1.209,0Zm4.231,0a.6.6,0,1,0,1.209,0h0a.6.6,0,1,0-1.209,0Zm4.04,1.022h0c-.01,0-.049-.006-.057-.006a.5.5,0,0,0-.543.418,5.021,5.021,0,0,1-9.9,0,.544.544,0,0,0-.539-.409h-.051a.512.512,0,0,1-.011-1.023h0c.008,0,.048.007.056.007a.5.5,0,0,0,.544-.418,5.087,5.087,0,0,1,2.535-3.559,3.15,3.15,0,0,0,2.872,2.583h.028a.5.5,0,0,0,.484-.373c0-.008.235-.794.828-.966a.513.513,0,0,0,.347-.632.5.5,0,0,0-.623-.352h0a2.281,2.281,0,0,0-1.36,1.255,2.3,2.3,0,0,1-1.632-1.921,5.008,5.008,0,0,1,6.278,3.364,5.086,5.086,0,0,1,.144.6.5.5,0,0,0,.543.417s.042,0,.059-.008a.457.457,0,0,1,.492.42h0a.474.474,0,0,1,0,.089.508.508,0,0,1-.494.516Zm.307-2.015a6.021,6.021,0,0,0-11.715,0,1.538,1.538,0,0,0,0,3,6.02,6.02,0,0,0,11.715,0,1.533,1.533,0,0,0,1.195-1.5,1.469,1.469,0,0,0-1.195-1.5Z",
    transform: "translate(-1005.375 -326.596)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(25 18)",
    fill: "#55595c",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))))), /*#__PURE__*/React.createElement("path", {
    id: "Colour_restaurant",
    d: "M0,0H338V8H0Z",
    transform: "translate(-4 221)",
    fill: "#f39b13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Card_Arrivals_1-2",
    "data-name": "Card Arrivals 1",
    transform: "translate(1244 2487.237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -280, -528.74)",
    filter: "url(#Base-fnb-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-7",
    "data-name": "Base",
    width: 398,
    height: 264,
    transform: "translate(276 533.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-more-vert-2",
    "data-name": "Icon metro-more-vert",
    d: "M18.368,13.6a2.944,2.944,0,1,0-2.944-2.944A2.943,2.943,0,0,0,18.368,13.6Zm0,2.944a2.944,2.944,0,1,0,2.944,2.944A2.943,2.943,0,0,0,18.368,16.544Zm0,8.831a2.944,2.944,0,1,0,2.944,2.944A2.943,2.943,0,0,0,18.368,25.375Z",
    transform: "translate(353.848 20.838)",
    fill: "#3a4750",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_name_2",
    "data-name": "{name}",
    transform: "translate(15 49.764)",
    fill: "#3a4750",
    fontSize: 28,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tai Restaurant")), /*#__PURE__*/React.createElement("g", {
    id: "Group_42403-2",
    "data-name": "Group 42403",
    transform: "translate(14.84 78.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PAX-3",
    "data-name": "PAX",
    transform: "translate(0 41.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adulti-3",
    "data-name": "Adulti",
    transform: "translate(0 3.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-5",
    "data-name": "icona",
    transform: "translate(0 3.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_adults-3",
    "data-name": "ic_adults",
    d: "M949.862,346.814H936.273a.436.436,0,0,1-.422-.433c-.025-.621-.029-2.118.461-2.612l.135-.144a4.358,4.358,0,0,1,3.015-1.427c1.513-.235,1.776-.9,1.863-1.121l.008-.021c-.011-.244-.026-.516-.035-.7a3.387,3.387,0,0,1-1.064-1.376,1.082,1.082,0,0,1-.733-.983l-.018-.131a.459.459,0,0,1-.006-.105,2.979,2.979,0,0,1,.506-1.721.662.662,0,0,1,.323-.173,6.518,6.518,0,0,1,.033-1.041c.107-1.113.582-1.838,1.3-1.981l.222-.046.02-.032a.6.6,0,0,1,.542-.237l.718-.154a1.405,1.405,0,0,1,1.08.589c.036.039.084.094.121.132a1.109,1.109,0,0,1,.6,0c.973.2.947,1.318.935,1.8,0,.081,0,.162,0,.244a2.505,2.505,0,0,1,.022.755.618.618,0,0,0,.082,0h0a.677.677,0,0,1,.553.265,2.674,2.674,0,0,1,.2,1.743,1.339,1.339,0,0,1-.753.94l-.118.075a4.376,4.376,0,0,1-.941,1.479c-.021.211-.055.562-.066.708v.018c.025.722,1.03.983,1.626,1.077a4.435,4.435,0,0,1,3.067,1.45l.117.126a5.216,5.216,0,0,1,.613,2.563.476.476,0,0,1-.116.335A.411.411,0,0,1,949.862,346.814Zm-13.172-.9h12.715a4.233,4.233,0,0,0-.321-1.489l-.134-.145a3.669,3.669,0,0,0-2.583-1.187c-1.995-.309-2.328-1.345-2.349-1.935.009-.259.084-1.025.084-1.025a.469.469,0,0,1,.141-.291,3.462,3.462,0,0,0,.888-1.388.445.445,0,0,1,.175-.229l.252-.161c.322-.2.325-.213.355-.344a2.874,2.874,0,0,0,0-.919.974.974,0,0,1-.753-.3.669.669,0,0,1-.124-.562,1.708,1.708,0,0,0,.007-.66,2.97,2.97,0,0,1-.011-.4c.015-.632-.043-.847-.24-.887a1.024,1.024,0,0,0-.21-.025.582.582,0,0,1-.383.047,1.062,1.062,0,0,1-.589-.422c-.112-.126-.282-.316-.383-.316l-.661.151a.492.492,0,0,1-.286.186,2.608,2.608,0,0,1-.483.127c-.461.092-.584.864-.616,1.191a6.038,6.038,0,0,0-.026,1.009.687.687,0,0,1-.125.545.741.741,0,0,1-.506.277,3.362,3.362,0,0,0-.2,1.006c.006.043.011.084.015.123a.909.909,0,0,0,.021.131.92.92,0,0,0,.352.2.443.443,0,0,1,.239.258,2.484,2.484,0,0,0,.975,1.243.454.454,0,0,1,.2.358s.037.632.055,1.077a.477.477,0,0,1-.087.294,2.944,2.944,0,0,1-2.512,1.646,3.6,3.6,0,0,0-2.531,1.164c-.056.062-.109.12-.162.173A3.835,3.835,0,0,0,936.69,345.911Zm3.765-9.153h0Zm5.4-.627v0Zm-5.543-.09a.12.12,0,0,0,0,.021Z",
    transform: "translate(-935.842 -332.372)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_30",
    "data-name": 30,
    transform: "translate(22.135 17)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "30"))), /*#__PURE__*/React.createElement("g", {
    id: "Kids-3",
    "data-name": "Kids",
    transform: "translate(59.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-6",
    "data-name": "icona"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-8",
    "data-name": "Base",
    width: 29.438,
    height: 28.26,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_kids-3",
    "data-name": "ic_kids",
    d: "M1020.3,341.6a2.42,2.42,0,0,1-2.687,0,.587.587,0,0,0-.837-.047.608.608,0,0,0-.046.85,3.48,3.48,0,0,0,4.455,0,.6.6,0,0,0-.05-.833.6.6,0,0,0-.831.028Zm-4.547-2.6a.712.712,0,1,0,1.423,0h0a.712.712,0,1,0-1.423,0Zm4.982,0a.712.712,0,1,0,1.423,0h0a.712.712,0,1,0-1.423,0Zm4.757,1.2h0c-.011,0-.058-.008-.067-.008a.589.589,0,0,0-.64.492,5.912,5.912,0,0,1-11.66,0,.641.641,0,0,0-.634-.482h-.059a.6.6,0,0,1-.013-1.205h0c.01,0,.057.008.065.008a.591.591,0,0,0,.64-.492,5.99,5.99,0,0,1,2.985-4.191,3.709,3.709,0,0,0,3.381,3.042h.032a.594.594,0,0,0,.569-.44c0-.01.277-.935.974-1.138a.6.6,0,0,0,.409-.744.592.592,0,0,0-.733-.415h0a2.686,2.686,0,0,0-1.6,1.478,2.713,2.713,0,0,1-1.922-2.262,5.9,5.9,0,0,1,7.393,3.962,5.963,5.963,0,0,1,.169.7.592.592,0,0,0,.64.492s.05-.006.069-.01a.538.538,0,0,1,.579.5h0a.56.56,0,0,1,0,.105.6.6,0,0,1-.582.608Zm.361-2.373a7.09,7.09,0,0,0-13.8.005,1.812,1.812,0,0,0,0,3.531,7.089,7.089,0,0,0,13.8,0,1.805,1.805,0,0,0,1.407-1.766,1.73,1.73,0,0,0-1.407-1.771Z",
    transform: "translate(-1004.437 -325.569)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(29.438 20.533)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42126-2",
    "data-name": "Group 42126",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Lunch-2",
    "data-name": "Lunch",
    transform: "translate(0.16 16.758)",
    fill: "#55595c",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lunch")), /*#__PURE__*/React.createElement("text", {
    id: "_30_",
    "data-name": "(30)",
    transform: "translate(61.16 16.758)",
    fill: "#55595c",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(30)")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42487-2",
    "data-name": "Group 42487",
    transform: "translate(14.84 169.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42400-2",
    "data-name": "Group 42400",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dinner-2",
    "data-name": "Dinner",
    transform: "translate(0.16 16.911)",
    fill: "#55595c",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dinner")), /*#__PURE__*/React.createElement("text", {
    id: "_72_",
    "data-name": "(72)",
    transform: "translate(65.16 16.911)",
    fill: "#55595c",
    fontSize: 18,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(72)"))), /*#__PURE__*/React.createElement("g", {
    id: "PAX-4",
    "data-name": "PAX",
    transform: "translate(0 41.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adulti-4",
    "data-name": "Adulti",
    transform: "translate(0 3.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-7",
    "data-name": "icona",
    transform: "translate(0 3.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_adults-4",
    "data-name": "ic_adults",
    d: "M949.862,346.814H936.273a.436.436,0,0,1-.422-.433c-.025-.621-.029-2.118.461-2.612l.135-.144a4.358,4.358,0,0,1,3.015-1.427c1.513-.235,1.776-.9,1.863-1.121l.008-.021c-.011-.244-.026-.516-.035-.7a3.387,3.387,0,0,1-1.064-1.376,1.082,1.082,0,0,1-.733-.983l-.018-.131a.459.459,0,0,1-.006-.105,2.979,2.979,0,0,1,.506-1.721.662.662,0,0,1,.323-.173,6.518,6.518,0,0,1,.033-1.041c.107-1.113.582-1.838,1.3-1.981l.222-.046.02-.032a.6.6,0,0,1,.542-.237l.718-.154a1.405,1.405,0,0,1,1.08.589c.036.039.084.094.121.132a1.109,1.109,0,0,1,.6,0c.973.2.947,1.318.935,1.8,0,.081,0,.162,0,.244a2.505,2.505,0,0,1,.022.755.618.618,0,0,0,.082,0h0a.677.677,0,0,1,.553.265,2.674,2.674,0,0,1,.2,1.743,1.339,1.339,0,0,1-.753.94l-.118.075a4.376,4.376,0,0,1-.941,1.479c-.021.211-.055.562-.066.708v.018c.025.722,1.03.983,1.626,1.077a4.435,4.435,0,0,1,3.067,1.45l.117.126a5.216,5.216,0,0,1,.613,2.563.476.476,0,0,1-.116.335A.411.411,0,0,1,949.862,346.814Zm-13.172-.9h12.715a4.233,4.233,0,0,0-.321-1.489l-.134-.145a3.669,3.669,0,0,0-2.583-1.187c-1.995-.309-2.328-1.345-2.349-1.935.009-.259.084-1.025.084-1.025a.469.469,0,0,1,.141-.291,3.462,3.462,0,0,0,.888-1.388.445.445,0,0,1,.175-.229l.252-.161c.322-.2.325-.213.355-.344a2.874,2.874,0,0,0,0-.919.974.974,0,0,1-.753-.3.669.669,0,0,1-.124-.562,1.708,1.708,0,0,0,.007-.66,2.97,2.97,0,0,1-.011-.4c.015-.632-.043-.847-.24-.887a1.024,1.024,0,0,0-.21-.025.582.582,0,0,1-.383.047,1.062,1.062,0,0,1-.589-.422c-.112-.126-.282-.316-.383-.316l-.661.151a.492.492,0,0,1-.286.186,2.608,2.608,0,0,1-.483.127c-.461.092-.584.864-.616,1.191a6.038,6.038,0,0,0-.026,1.009.687.687,0,0,1-.125.545.741.741,0,0,1-.506.277,3.362,3.362,0,0,0-.2,1.006c.006.043.011.084.015.123a.909.909,0,0,0,.021.131.92.92,0,0,0,.352.2.443.443,0,0,1,.239.258,2.484,2.484,0,0,0,.975,1.243.454.454,0,0,1,.2.358s.037.632.055,1.077a.477.477,0,0,1-.087.294,2.944,2.944,0,0,1-2.512,1.646,3.6,3.6,0,0,0-2.531,1.164c-.056.062-.109.12-.162.173A3.835,3.835,0,0,0,936.69,345.911Zm3.765-9.153h0Zm5.4-.627v0Zm-5.543-.09a.12.12,0,0,0,0,.021Z",
    transform: "translate(-935.842 -332.372)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_56",
    "data-name": 56,
    transform: "translate(22.135 17)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "56"))), /*#__PURE__*/React.createElement("g", {
    id: "Kids-4",
    "data-name": "Kids",
    transform: "translate(67.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-8",
    "data-name": "icona"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-9",
    "data-name": "Base",
    width: 29,
    height: 29,
    transform: "translate(0.041 -0.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_kids-4",
    "data-name": "ic_kids",
    d: "M1020.3,341.6a2.42,2.42,0,0,1-2.687,0,.587.587,0,0,0-.837-.047.608.608,0,0,0-.046.85,3.48,3.48,0,0,0,4.455,0,.6.6,0,0,0-.05-.833.6.6,0,0,0-.831.028Zm-4.547-2.6a.712.712,0,1,0,1.423,0h0a.712.712,0,1,0-1.423,0Zm4.982,0a.712.712,0,1,0,1.423,0h0a.712.712,0,1,0-1.423,0Zm4.757,1.2h0c-.011,0-.058-.008-.067-.008a.589.589,0,0,0-.64.492,5.912,5.912,0,0,1-11.66,0,.641.641,0,0,0-.634-.482h-.059a.6.6,0,0,1-.013-1.205h0c.01,0,.057.008.065.008a.591.591,0,0,0,.64-.492,5.99,5.99,0,0,1,2.985-4.191,3.709,3.709,0,0,0,3.381,3.042h.032a.594.594,0,0,0,.569-.44c0-.01.277-.935.974-1.138a.6.6,0,0,0,.409-.744.592.592,0,0,0-.733-.415h0a2.686,2.686,0,0,0-1.6,1.478,2.713,2.713,0,0,1-1.922-2.262,5.9,5.9,0,0,1,7.393,3.962,5.963,5.963,0,0,1,.169.7.592.592,0,0,0,.64.492s.05-.006.069-.01a.538.538,0,0,1,.579.5h0a.56.56,0,0,1,0,.105.6.6,0,0,1-.582.608Zm.361-2.373a7.09,7.09,0,0,0-13.8.005,1.812,1.812,0,0,0,0,3.531,7.089,7.089,0,0,0,13.8,0,1.805,1.805,0,0,0,1.407-1.766,1.73,1.73,0,0,0-1.407-1.771Z",
    transform: "translate(-1004.437 -325.569)",
    fill: "#55595c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_16",
    "data-name": 16,
    transform: "translate(29.041 20.698)",
    fill: "#55595c",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16"))))), /*#__PURE__*/React.createElement("path", {
    id: "Colour_restaurant-2",
    "data-name": "Colour_restaurant",
    d: "M0,0H398V9.42H0Z",
    transform: "translate(-4 259.343)",
    fill: "#1372f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52239",
    "data-name": "Group 52239",
    transform: "translate(-62.372 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1026.37, 1968.5)",
    filter: "url(#Base-fnb-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-10",
    "data-name": "Base",
    width: 388,
    height: 347,
    transform: "translate(138 291.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Button_Link",
    "data-name": "Button Link",
    transform: "translate(1439.372 2542)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Detail",
    transform: "translate(27 22)",
    fill: "#3a4750",
    fontSize: 21,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    textDecoration: "underline"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.265,
    y: 0
  }, "Detail"))), /*#__PURE__*/React.createElement("text", {
    id: "Guest_1",
    "data-name": "Guest 1",
    transform: "translate(1185.372 2506)",
    fill: "#3a4750",
    fontSize: 18,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Restaurant Beach")), /*#__PURE__*/React.createElement("g", {
    id: "Check-in",
    transform: "translate(1185.767 2442.157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_03_02_2022",
    "data-name": "03/02/2022",
    transform: "translate(27.605 16.843)",
    fill: "#3a4750",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "03/02/2022")), /*#__PURE__*/React.createElement("g", {
    id: "ic_check-in",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3507",
    "data-name": "Rectangle 3507",
    width: 23,
    height: 23,
    transform: "translate(-0.395 -0.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42593",
    "data-name": "Group 42593",
    transform: "translate(4.493 4.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33207",
    "data-name": "Path 33207",
    d: "M525.4,237.008a.326.326,0,0,0-.323-.323h-.648a.326.326,0,0,0-.325.323v.972h1.3Z",
    transform: "translate(-521.491 -236.685)",
    fill: "#3a4750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33208",
    "data-name": "Path 33208",
    d: "M530.682,237.008a.326.326,0,0,0-.323-.323h-.648a.325.325,0,0,0-.323.325v.97h1.295Z",
    transform: "translate(-519.471 -236.685)",
    fill: "#3a4750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33336",
    "data-name": "Path 33336",
    d: "M534.7,237.622h-1.28v.972a.324.324,0,0,1-.325.323h-.647a.326.326,0,0,1-.325-.323v-.972h-6.011v.972a.323.323,0,0,1-.323.323h-.648a.324.324,0,0,1-.323-.323v-.972h-1.28a1.382,1.382,0,0,0-1.328,1.424v9.679a1.382,1.382,0,0,0,1.328,1.424H534.7a1.383,1.383,0,0,0,1.33-1.424v-9.679A1.383,1.383,0,0,0,534.7,237.622Zm.267,10.675a.691.691,0,0,1-.665.712H523.939a.689.689,0,0,1-.663-.712v-6.4a.275.275,0,0,1,.265-.285H534.7a.277.277,0,0,1,.267.285Z",
    transform: "translate(-522.212 -236.327)",
    fill: "#3a4750"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Check-in-2",
    "data-name": "Check-in",
    transform: "translate(1323.244 2442.157)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20:30",
    "data-name": "20:30",
    transform: "translate(27.128 16.843)",
    fill: "#3a4750",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20:30")), /*#__PURE__*/React.createElement("g", {
    id: "ic_check-in-2",
    "data-name": "ic_check-in",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3507-2",
    "data-name": "Rectangle 3507",
    width: 22,
    height: 23,
    transform: "translate(0.128 -0.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-clock",
    "data-name": "Icon feather-clock",
    transform: "translate(3.845 4.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_33209",
    "data-name": "Path 33209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_106",
    "data-name": "Union 106",
    d: "M0,6.91a6.91,6.91,0,1,1,6.911,6.911A6.918,6.918,0,0,1,0,6.91Zm1.256,0A5.654,5.654,0,1,0,6.911,1.256,5.661,5.661,0,0,0,1.256,6.91ZM9.142,8.729,6.63,7.472a.625.625,0,0,1-.348-.561V3.141a.628.628,0,0,1,1.256,0V6.522L9.7,7.605a.628.628,0,0,1-.562,1.124Z",
    fill: "#3a4750",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Pax-5",
    "data-name": "Pax",
    transform: "translate(1185.767 2408.933)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_PAX",
    "data-name": "2 PAX",
    transform: "translate(27.605 17.067)",
    fill: "#3a4750",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2 PAX")), /*#__PURE__*/React.createElement("g", {
    id: "ic_pax",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3639",
    "data-name": "Rectangle 3639",
    width: 23,
    height: 23,
    transform: "translate(-0.395 0.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_pax-2",
    "data-name": "ic_pax",
    d: "M13.558,12.482a2.3,2.3,0,1,0-2.262-2.3A2.29,2.29,0,0,0,13.558,12.482Zm-6.031,0a2.3,2.3,0,1,0-2.262-2.3A2.29,2.29,0,0,0,7.527,12.482Zm0,1.689c-1.772,0-5.277.883-5.277,2.687v2.073H12.912V16.859C12.912,15.054,9.3,14.171,7.527,14.171Zm6.031.422a3.882,3.882,0,0,0-.646.038A2.308,2.308,0,0,1,14.1,16.859v2.073h4.739V16.859C18.835,15.054,15.33,14.594,13.558,14.594Z",
    transform: "translate(0.861 -2.013)",
    fill: "#3a4750"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RES_283",
    "data-name": "RES 283",
    transform: "translate(1185.372 2393)",
    fill: "#b5b5b5",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RES 283")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-more-vert-3",
    "data-name": "Icon metro-more-vert",
    d: "M18.88,14.623a3.455,3.455,0,1,0-3.455-3.455A3.454,3.454,0,0,0,18.88,14.623Zm0,3.455a3.455,3.455,0,1,0,3.455,3.455A3.454,3.454,0,0,0,18.88,18.078Zm0,10.366A3.455,3.455,0,1,0,22.335,31.9,3.454,3.454,0,0,0,18.88,28.444Z",
    transform: "translate(1507.924 2279.93)",
    fill: "#3a4750",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_name_3",
    "data-name": "{name}",
    transform: "translate(1185.372 2313)",
    fill: "#3a4750",
    fontSize: 33,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Angela Ellis")), /*#__PURE__*/React.createElement("g", {
    id: "Group_42590",
    "data-name": "Group 42590",
    transform: "translate(1279.71 2408.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42191",
    "data-name": "Group 42191",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3639-2",
    "data-name": "Rectangle 3639",
    width: 23,
    height: 23,
    transform: "translate(-0.338 0.067)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42192",
    "data-name": "Group 42192",
    transform: "translate(4.533 4.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M12.911,12.911A3.455,3.455,0,1,0,9.455,9.455,3.454,3.454,0,0,0,12.911,12.911Zm0,1.728C10.6,14.638,6,15.8,6,18.093v1.728H19.821V18.093C19.821,15.8,15.217,14.638,12.911,14.638Z",
    transform: "translate(-6 -6)",
    fill: "#3a4750"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_name_4",
    "data-name": "{name}",
    transform: "translate(22.662 17.067)",
    fill: "#3a4750",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42592",
    "data-name": "Group 42592",
    transform: "translate(1323.244 2408.933)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_name_5",
    "data-name": "{name}",
    transform: "translate(22.127 17.067)",
    fill: "#3a4750",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("g", {
    id: "Group_42591",
    "data-name": "Group 42591",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42384",
    "data-name": "Group 42384",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3639-3",
    "data-name": "Rectangle 3639",
    width: 22,
    height: 23,
    transform: "translate(0.128 0.067)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_93",
    "data-name": "Union 93",
    d: "M3.166,10.26A5.843,5.843,0,0,1,1.8,8.374,2.585,2.585,0,0,1,.038,6.3a2.481,2.481,0,0,1,0-.862A2.576,2.576,0,0,1,1.8,3.374a5.82,5.82,0,0,1,1.376-1.9,5.457,5.457,0,0,1,7.463,0,5.929,5.929,0,0,1,1.376,1.9,2.585,2.585,0,0,1,1.765,2.069,2.477,2.477,0,0,1,0,.862,2.579,2.579,0,0,1-1.759,2.069,5.916,5.916,0,0,1-1.363,1.886,5.462,5.462,0,0,1-7.495,0Zm.069-1.886a4.3,4.3,0,0,0,7.35,0,4.777,4.777,0,0,0,.541-1.214,1.78,1.78,0,0,0,.182.02,1.306,1.306,0,0,0,0-2.611,1.676,1.676,0,0,0-.182.02,4.771,4.771,0,0,0-.541-1.214,4.3,4.3,0,0,0-7.35,0A4.765,4.765,0,0,0,2.7,4.588a1.7,1.7,0,0,0-.182-.02,1.306,1.306,0,0,0,0,2.611A1.808,1.808,0,0,0,2.7,7.16,4.772,4.772,0,0,0,3.235,8.374ZM4.083,7.18H9.737A3.084,3.084,0,0,1,6.91,9.138,3.084,3.084,0,0,1,4.083,7.18ZM7.7,4.895a.786.786,0,1,1,.785.816A.8.8,0,0,1,7.7,4.895Zm-3.141,0a.786.786,0,1,1,.786.816A.8.8,0,0,1,4.555,4.895Z",
    transform: "translate(3.844 5.171)",
    fill: "#3a4750"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Print_Button",
    "data-name": "Print Button",
    transform: "translate(1185.767 2534.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    transform: "translate(-0.395 0.046)",
    fill: "#b54756",
    stroke: "#b54756",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 50,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 219,
    height: 49,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41763",
    "data-name": "Group 41763",
    transform: "translate(63.01 12.602)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Guest_Arrived",
    "data-name": "Guest Arrived",
    transform: "translate(63.595 19.444)",
    fill: "#eceef0",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -63.687,
    y: 0
  }, "Guest Arrived"))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-double",
    "data-name": "Icon awesome-check-double",
    d: "M28.626,8.964,26.381,6.933a1.458,1.458,0,0,0-1.922,0L10.883,19.215,4.568,13.5a1.458,1.458,0,0,0-1.922,0L.4,15.533a1.151,1.151,0,0,0,0,1.744L9.919,25.9a1.458,1.458,0,0,0,1.922,0L28.62,10.707A1.155,1.155,0,0,0,28.626,8.964ZM10.243,14.4a.968.968,0,0,0,1.281,0L23.315,3.723a.769.769,0,0,0,0-1.159L20.752.241a.968.968,0,0,0-1.281,0L10.883,8.01,7.743,5.164a.968.968,0,0,0-1.281,0L3.894,7.487a.769.769,0,0,0,0,1.159Z",
    transform: "translate(22.464 12.526)",
    fill: "#eceef0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tag_Status",
    "data-name": "Tag Status",
    transform: "translate(1185.767 2332.176)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3698",
    "data-name": "Rectangle 3698",
    width: 71,
    height: 33,
    rx: 16.5,
    transform: "translate(-0.395 -0.175)",
    fill: "rgba(21,157,247,0.2)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Open",
    transform: "translate(11.605 22.824)",
    fill: "#159df7",
    fontSize: 20,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Open"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescQuadroFnb);
export default __webpack_public_path__ + "static/media/desc-quadro-fnb.e0e455d50c4edb4e64d3c2a8ee418ce2.svg";
export { ForwardRef as ReactComponent };